// @flow
import React from 'react';
import styles from './multiSelectList.scss';

type Props = {
  optionsArr: Array<any>,
  onSelect: Function,
  accessorKeys: Object
};

type State = {
  optionsArr: Array<any>
};

const rowUnselectedImg = require('../../../../assets/images/ic_check_box_outline_blank_black_24px.svg');
const rowSelectedImg = require('../../../../assets/images/selected-checked.svg');

class MultiSelectList extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      optionsArr: this.props.optionsArr
    };
    this.accessorKeys = this.props.accessorKeys;

    this.keyName = this.accessorKeys.key || 'key';
    this.selectFlag = this.accessorKeys.selectFlag || 'isSelected';
  }

  componentWillReceiveProps(nextProps: Object) {
    this.setOptionsArr(nextProps);
  }

  onOptionSelect(rowObj: Object, i: number) {
    if (this.props.onSelect) {
      this.props.onSelect(rowObj, i);
    }
  }
  setOptionsArr(nextProps: Object) {
    this.setState({
      optionsArr: nextProps.optionsArr
    });
  }

  accessorKeys: Object;
  keyName: string;
  selectFlag: string;
  render() {
    return (
      <div className="multi-select-list-wrapper">
        <div className="options-row-wrapper">
          {this.state.optionsArr.map((elem, i) => (
            <div
              key={i}
              className={`${styles.optionsRow} l-row j-space-bet`}
              onClick={() => this.onOptionSelect(elem, i)}
            >
              <div className={`${styles.rowText}`}>{elem[this.keyName]}</div>
              <div className={`${styles.rowCheck}`}>
                <img
                  src={
                    !elem[this.selectFlag] ? rowUnselectedImg : rowSelectedImg
                  }
                  alt="Select"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default MultiSelectList;
